import Modal from '@material-ui/core/Modal'
import React from 'react'
import CrossSvg from '../../../../assets/images/cross.svg'
import AlertSvg from '../../../../assets/images/ic-alert.svg'
import QrSvg from '../../../../assets/images/icon-qr.svg'
import InternetSvg from '../../../../assets/images/ic_disconnected.svg'
import CheckSvg from '../../../../assets/images/white-check.svg'
import CustomButton from '../CustomButton'
import './MessageModal.scss'

const getColor = (type) => {
  switch (type) {
    case 1: return '#FF6868'
    case 2: return '#FF6868'
    case 3: return '#f2f2f2'
    case 10: return '#FF6868'
    case 11: return '#9240c9'
    case 12: return '#FF6868'
    case 13: return '#9240c9'
    case 14: return '#9240c9'
    case 24: return '#FF6868'
    case 21: return '#FF6868'
    default: return '#f2f2f2'
  }
}

const getColorButton = (type) => {
  switch (type) {
    case 1: return '#FF6868'
    case 2: return '#FF6868'
    case 12: return '#FF6868'
    case 13: return '#9240c9'
    case 14: return '#9240c9'
    case 24: return '#FF6868'
    case 21: return '#FF6868'
    default: return '#9240c9'
  }
}

const getImage = (type) => {
  switch (type) {
    case 1: return require('../../../../assets/images/icono-alerta.png')
    case 2: return require('../../../../assets/images/no-internet.png')
    case 3: return require('../../../../assets/images/icono-pregunta.png')
    default: return require('../../../../assets/images/icono-check.png')
  }
}

export default function SimpleModal({ visible, closeModal, message, type, txtBtn1, txtBtn2, onClickBtn1, onClickBtn2, title, inlineButtons, children, disabled }) {
  // console.log("type modal!", type)
  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={visible}
        onClose={closeModal}
        style={{ overflow: 'scroll' }}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div className="modal-container">
          <div className='modal-header' style={{ backgroundColor: getColor(type) }}>
            {
              type === 10 ? (
                <p className='modal-info-header'>{title}</p>
              ) : type === 11 ? (
                <div className='modal-info-container'>
                  <img src={CheckSvg} alt='ok' />
                  <p>{title}</p>
                </div>
              ) : type === 12 ? (
                <div className='modal-info-container'>
                  <img src={AlertSvg} alt='error' />
                  <p>{title}</p>
                </div>
              ) : type === 13 ? (
                <div className='modal-info-container'>
                  <img src={QrSvg} alt='error' />
                  <p>{title}</p>
                </div>
              ) : type === 14 ? (
                <div className='modal-info-container'>
                  <p>{title}</p>
                </div>
              ) : type === 21 ? (
                <div className='modal-info-container'>
                  <img src={CrossSvg} alt='error' />
                  <p>{title}</p>
                </div>
              ) : type === 24 ? (
                <div className='modal-info-container'>
                  <img src={InternetSvg} alt='error' />
                  <p>{title}</p>
                </div>
              ) : (
                <img src={getImage(type)} height='80%' width='auto' alt='icon-notif' />
              )
            }
          </div>
          {
            (type === 14) ? (
              <div className='modal-body-fixed'>
                {children || message}
              </div>
            ) : (
              <div className='modal-body'>
              {
                (type >= 10 && type < 20) ? (
                  children || message
                ) : (
                  <p>{message}</p>
                )
              }
              </div>
            )
          }
          {(txtBtn1 || txtBtn2) &&
            <div className={`modal-footer ${inlineButtons ? 'inline' : null}`}>
              {txtBtn1 &&
                <CustomButton
                  margin='0'
                  onClick={onClickBtn1}
                  color={type === 10 ? '#FF6868' : getColorButton(type)}
                  width={!txtBtn2 ? '100% !important' : null}>
                  {txtBtn1}
                </CustomButton >}
              {txtBtn2 &&
                <CustomButton 
                  filled={true}
                  margin='0'
                  onClick={onClickBtn2}
                  color={type === 10 ? '#9240c9' : getColorButton(type)}
                  width={!txtBtn1 ? '100% !important' : null}
                  disabled={disabled}
                >
                  {txtBtn2}
                </CustomButton >}
            </div>
          }
        </div>
      </Modal>
    </div>
  )
}
